
import React from "react";
import { Badge } from "@/components/ui/badge";
import { MapPin } from "lucide-react";

interface CoordinatesDisplayProps {
  lat: number;
  lng: number;
  className?: string;
}

const CoordinatesDisplay = ({ lat, lng, className }: CoordinatesDisplayProps) => {
  const handleOpenMaps = () => {
    const url = `https://www.google.com/maps?q=${lat},${lng}`;
    window.open(url, '_blank');
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <MapPin className="h-4 w-4 text-muted-foreground" />
      <Badge 
        variant="outline" 
        className="cursor-pointer hover:bg-sky-mist/20 transition-colors"
        onClick={handleOpenMaps}
        title="Click to view on Google Maps"
      >
        {lat.toFixed(6)}, {lng.toFixed(6)}
      </Badge>
    </div>
  );
};

export default CoordinatesDisplay;
